import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import { FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { NS, U3147ROLES } from '../../U3147';

export interface U3147DayTimelineToolBarProps {
  onAddRange: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onExportDay: () => void;
  exportBusy?: boolean;
  disableEdit?: boolean;
  disableDelete?: boolean;
}

const U3147DayTimelineToolBar: React.FC<U3147DayTimelineToolBarProps> = ({
  onAddRange,
  onEdit,
  onDelete,
  onExportDay,
  exportBusy,
  disableEdit = true,
  disableDelete = true,
}) => {
  const { t } = useTranslation();
  const { hasRole } = useU2000AuthContext();

  const actions = [
    {
      key: 'addRange',
      label: t('btnAddRange', { ns: NS, defaultValue: '+ Ajouter une plage' }),
      hasRole: hasRole(U3147ROLES.TRACK),
      handleClick: onAddRange,
      Component: U2000ActionBtn,
    },
    {
      key: 'edit',
      label: t('btnEdit', { ns: 'common', defaultValue: 'Éditer' }),
      hasRole: hasRole(U3147ROLES.EDIT),
      handleClick: onEdit,
      disabled: disableEdit,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: 'common', defaultValue: 'Supprimer' }),
      hasRole: hasRole(U3147ROLES.DELETE),
      handleClick: onDelete,
      disabled: disableDelete,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
    {
      key: 'exportDay',
      label: t('btnExportDay', { ns: NS, defaultValue: 'Exporter ma journée' }),
      hasRole: hasRole(U3147ROLES.EXPORT),
      handleClick: onExportDay,
      disabled: exportBusy,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};

export default U3147DayTimelineToolBar;
